@if (photoUrl()) {
  <img [src]="photoUrl()" alt="Profile Picture" />
} @else {
  {{ initial() }}
}
